// Sensory subsection questionnaire constants
export enum SensoryQuestionnaireItem {
  MEDICAL_BACKGROUND_SENSORY = 'medical-background/sensory',
  MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES = 'medical-background/sensory/sensory-status-eyes',
  MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS = 'medical-background/sensory/sensory-status-ears',
  MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE = 'medical-background/sensory/sensory-status-nose',
  MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH = 'medical-background/sensory/sensory-status-touch',
  MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE = 'medical-background/sensory/sensory-status-taste',
  MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY = 'medical-background/sensory/system-summary'
}
